import * as Store from '@apply/store';
import { FeatureType } from '@apply/constants';

export const isSafeRedirect = (url: string): boolean => {
    try {
        if (url.startsWith('//')) return false;
        if (url.startsWith('/')) return true;
        const parsed = new URL(url, window.location.origin);
        return parsed.hostname === window.location.hostname;
    } catch {
        return false;
    }
};

export const getPostLoginDestination = (search: string): string => {
    const redirectTo = new URLSearchParams(search).get('redirectTo');

    if (redirectTo !== null) {
        return redirectTo && isSafeRedirect(redirectTo) ? redirectTo : '/home';
    }

    const auth = Store.UserStore.Types.retrieve();
    const isGeneralContractor =
        Store.UserStore.Types.isFeatureEnabled(auth.user, FeatureType.GeneralContractor) &&
        auth?.user.isGeneralContractor;

    return isGeneralContractor ? '/entity-selection' : '/home';
};
